import { render, staticRenderFns } from "./EmasTersediaCabangView.vue?vue&type=template&id=5f920b7a&scoped=true&"
import script from "./EmasTersediaCabangView.vue?vue&type=script&lang=js&"
export * from "./EmasTersediaCabangView.vue?vue&type=script&lang=js&"
import style0 from "./EmasTersediaCabangView.vue?vue&type=style&index=0&id=5f920b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f920b7a",
  null
  
)

export default component.exports